module.exports = __webpack_public_path__ + "static/media/leave_club_2.decb4248.png";